import React, { useState, useEffect, useContext, useRef } from "react";
import EmpresaContext from "../../../../../../contexts/Empresa";
import api from "../../../../../../services/api";
import Avatar from "../../../Avatar";
import { Progress } from "reactstrap";

// svg
import goldPosition from "../../../../../../assets/img/PlayneeRanking/Ouro.png";
import silverPosition from "../../../../../../assets/img/PlayneeRanking/Prata.png";
import bronzePosition from "../../../../../../assets/img/PlayneeRanking/Bronze.png";
//
import "./style.css";

interface Props {
  empresas: Array<any>;
  unidade: any;
  pageProperties: any;
  onTableChange(
    type: string,
    sortProperties: {
      page: number;
      sizePerPage: number;
      sortField: string;
      sortOrder: string;
    }
  ): Promise<void>;
  notify(type: string, msg: string): void;
  loading: boolean;
}

export const Ranking: React.FC<Props> = ({
  empresas,
  unidade,
  pageProperties,
  onTableChange,
  notify,
  loading,
  ...props
}) => {
  function convertToMoney(value: number) {
    if (unidade && unidade == "M") {
      return Number(value).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    } else {
      return parseInt(String(value));
    }
  }

  const parseSafe = (val: any): number => {
    if (typeof val === "string") {
      // se contém vírgula (ex: "13.333,33")
      if (val.includes(",")) {
        return Number(val.replace(/\./g, "").replace(",", "."));
      }
      // se já vem em ponto (ex: "13333.33")
      return Number(val);
    }

    // se já é number
    if (typeof val === "number") return val;

    return 0;
  };

  const EmpresaItem: React.FC<{ data: any[] }> = ({ data }) => {
    if (data.length === 0) {
      return (
        <div className="rankingLateralNoItem">
          <p>Nenhum item encontrado</p>
        </div>
      );
    } else {
      const sortedData = [...data].sort((a, b) => {
        const percentA =
          parseFloat(a.meta_geral) > 0
            ? (parseFloat(a.vendas_geral) / parseFloat(a.meta_geral)) * 100
            : 0;
        const percentB =
          parseFloat(b.meta_geral) > 0
            ? (parseFloat(b.vendas_geral) / parseFloat(b.meta_geral)) * 100
            : 0;
        return percentB - percentA;
      });

      return (
        <>
          {sortedData.map((item, index) => {
            const vendas = parseSafe(item.vendas_geral);
            const meta = parseSafe(item.meta_geral);
            const percentual =
              meta > 0 ? Math.min(Math.round((vendas / meta) * 100), 100) : 0;

            const faltam = Math.max(0, meta - vendas);

            switch (index) {
              case 0:
                return (
                  <div
                    className="rankingLateralEmpresas destaque-primeiro"
                    key={index + 1}
                  >
                    <div className="rankingPosicaoEmpresas">
                      <p className="posicao-number">{index + 1}</p>
                    </div>
                    <div className="container-ranking">
                      <div className="boxAvatar">
                        <Avatar
                          title={item.empresa.nome}
                          user={item.empresa}
                          className="avatar"
                          style={{
                            cursor: "default",
                            border: "3px #A5826D solid",
                            width: "80px",
                            height: "80px",
                          }}
                        />
                      </div>
                      <div className="boxInfoRanking">
                        <div className="boxUserName">
                          <p className="nomeEmpresaLateral">
                            {item.empresa.nome}
                          </p>
                        </div>
                        <div className="boxMetaEmpresas">
                          <div className="boxMeta-venda-empresas">
                            <p className="paragraph-empresas">Vendas: </p>
                            <p className="venda-empresas">
                              {convertToMoney(parseSafe(item.vendas_geral))}
                            </p>
                          </div>
                          <div className="boxMeta-meta-empresas">
                            <p>Meta: </p>
                            <p className="meta-empresas">
                              {convertToMoney(parseSafe(item.meta_geral))}
                            </p>
                          </div>
                        </div>
                        <div className="container-progress">
                          <Progress
                            value={percentual}
                            color="info"
                            style={{
                              width: "70%",
                              height: "8px",
                              borderRadius: "10px",
                              margin: 0,
                            }}
                          />
                          <span className="percentual-text">{percentual}%</span>
                        </div>
                        <div className="boxMeta-faltam-empresas">
                          <p className="paragraph-empresas">Faltam: </p>
                          <p className="faltam-empresas">
                            {convertToMoney(faltam)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );

              default:
                return (
                  <div className="rankingLateralEmpresas">
                    <div className="rankingPosicaoEmpresas">
                      <p className="posicao-number">{index + 1}</p>
                    </div>
                    <div className="container-ranking">
                      <div className="boxAvatar">
                        <Avatar
                          title={item.empresa.nome}
                          user={item.empresa}
                          className="avatar"
                          style={{
                            cursor: "default",
                            border: "3px #A5826D solid",
                            width: "80px",
                            height: "80px",
                          }}
                        />
                      </div>
                      <div className="boxInfoRanking">
                        <div className="boxUserName">
                          <p className="nomeEmpresaLateral">
                            {item.empresa.nome}
                          </p>
                        </div>
                        <div className="boxMetaEmpresas">
                          <div className="boxMeta-venda-empresas">
                            <p>Vendas: </p>
                            <p className="venda-empresas">
                              {convertToMoney(item.vendas_geral)}
                            </p>
                          </div>
                          <div className="boxMeta-meta-empresas">
                            <p>Meta: </p>
                            <p className="meta-empresas">
                              {convertToMoney(item.meta_geral)}
                            </p>
                          </div>
                        </div>
                        <div className="container-progress">
                          <Progress
                            value={percentual}
                            color="info"
                            style={{
                              width: "70%",
                              height: "8px",
                              borderRadius: "10px",
                              margin: 0,
                            }}
                          />
                          <span className="percentual-text">{percentual}%</span>
                        </div>
                        <div className="boxMeta-faltam-empresas">
                          <p>Faltam: </p>
                          <p className="faltam-empresas">
                            {convertToMoney(faltam)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
            }
          })}
        </>
      );
    }
  };

  // tentativa de retornar jsx com o card gold completo e posicionado

  const Gold: React.FC<{ data: any | null }> = ({ data }) => {
    console.log(data);
    if (data !== null) {
      return (
        <>
          {/* titulo do desafio */}
          {/* <h1 className='tituloRanking'>MAISLASER</h1> */}
          <img className="goldPosition" src={goldPosition} />
          <div className="goldAvatar">
            <Avatar
              title={data.empresa.nome}
              user={data.empresa}
              className="avatar"
              style={{
                cursor: "default",
              }}
            />
            <div className={`nomePodioContainer nomePodio-gold`}>
              <p className="nomePodio" title={data.empresa.nome}>
                {data.empresa.nome.split(" ").slice(0, 3).join(" ")}
              </p>
            </div>
          </div>
          {/* premio */}
          {/* <div className='premio'>
            <div className='premioGold' />
            <p>JBL</p>
          </div> */}
        </>
      );
    } else {
      return (
        <>
          <img className="goldPosition" src={goldPosition} />
          <div className="goldElipse">
            <div className="elipse" />
          </div>
        </>
      );
    }
  };

  const Silver: React.FC<{ data: any | null }> = ({ data }) => {
    if (data !== null) {
      return (
        <>
          <div className="tituloRanking"></div>
          <img className="silverPosition" src={silverPosition} />
          <div className="silverAvatar">
            <Avatar
              title={data.empresa.nome}
              user={data.empresa}
              className="avatar"
              style={{
                cursor: "default",
              }}
            />
            <div className={`nomePodioContainer nomePodio-silver`}>
              <p className="nomePodio" title={data.empresa.nome}>
                {data.empresa.nome}
              </p>
            </div>
          </div>
          {/* premio */}
          {/* <div className='premio'>
            <div className='premioSilver' />
            <p>Ingressos</p>
          </div> */}
        </>
      );
    } else {
      return (
        <>
          <img className="silverPosition" src={silverPosition} />
          <div className="silverElipse">
            <div className="elipse" />
          </div>
        </>
      );
    }
  };

  const Bronze: React.FC<{ data: any | null }> = ({ data }) => {
    if (data !== null) {
      return (
        <>
          <img className="bronzePosition" src={bronzePosition} />
          <div className="bronzeAvatar">
            <Avatar
              title={data.empresa.nome}
              user={data.empresa}
              className="avatar"
              style={{
                cursor: "default",
              }}
            />
            <div className={`nomePodioContainer nomePodio-bronze`}>
              <p className="nomePodio" title={data.empresa.nome}>
                {data.empresa.nome.split(" ").slice(0, 3).join(" ")}
              </p>
            </div>
          </div>
          {/* premio */}
          {/* <div className='premio'>
            <div className='premioBronze' />
            <p>Chocolate</p>
          </div> */}
        </>
      );
    } else {
      return (
        <>
          <img className="bronzePosition" src={bronzePosition} />
          <div className="bronzeElipse">
            <div className="elipse" />
          </div>
        </>
      );
    }
  };

  return (
    <div className="ranking">
      <div className="podioColaboradores">
        <div className="silverColaborador">
          <Silver data={empresas && empresas[1] ? empresas[1] : null} />
        </div>
        <div className="goldColaborador">
          <Gold data={empresas && empresas[0] ? empresas[0] : null} />
        </div>
        <div className="bronzeColaborador">
          <Bronze data={empresas && empresas[2] ? empresas[2] : null} />
        </div>
      </div>
      <div className="rankingTenEmpresas">
        <EmpresaItem data={empresas} />
      </div>
    </div>
  );
};
